var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "movie-box as-flex main-start cross-start" },
    [
      _vm.type === "multi"
        ? _c(
            "div",
            { staticClass: "multi-container as-flex main-center cross-center" },
            [
              _c("i", {
                class: [
                  "multi-select",
                  _vm.chosen ? "chosenCircle" : "notchosenCircle",
                ],
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "main-box" }, [
        _c(
          "div",
          { staticClass: "title-row f-3 as-flex main-start cross-center" },
          [_c("span", [_vm._v(_vm._s(_vm.movieInfo.movie_name || "--"))])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "type-row as-flex flex-horizontal main-start cross-center f-2",
          },
          [
            _c("div", { staticClass: "box-time" }, [
              _vm._v(
                _vm._s(_vm.movieInfo.movie.launch || "--:--:--") +
                  " (" +
                  _vm._s(
                    _vm.weekMapping[_vm.movieInfo.movie.day] || "--:--:--"
                  ) +
                  ")"
              ),
            ]),
            _vm._v(" "),
            _vm._l(_vm.movieInfo.movie.tags || [], function (item, index) {
              return [
                _c(
                  "div",
                  {
                    key: item.id,
                    class: ["box-type", index === 0 ? "is-first" : ""],
                  },
                  [_vm._v(_vm._s(item.name))]
                ),
              ]
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "box-row as-flex flex-horizontal main-start cross-center f-2",
          },
          [
            _c("div", { staticClass: "total-box" }, [
              _vm._v("综合票房: " + _vm._s(_vm.movieInfo.movie.box)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "first-week-box" }, [
              _vm._v("首周票房: " + _vm._s(_vm.movieInfo.movie.first_week_box)),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "tag-row as-flex flex-horizontal main-start cross-center f-2",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "cycle as-flex flex-horizontal main-center cross-center f-2",
              },
              [
                _vm._v(
                  _vm._s(_vm.offsetMaaping[_vm.movieInfo.offset] || "-- --")
                ),
              ]
            ),
            _vm._v(" "),
            ["0.0", "-1.0", "-2.0", "-3.0", "-4.0"].includes(
              _vm.movieInfo.offset
            )
              ? [
                  _vm._l(_vm.beforeTags, function (item) {
                    return [
                      _c("div", { key: item.id, staticClass: "tag1" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.value) +
                            "\n            "
                        ),
                        _c(
                          "span",
                          {
                            class: [
                              _vm.movieInfo.base < 50 ? "is-warning" : "",
                            ],
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.movieInfo[item.id] === null
                                  ? "-- --"
                                  : Number(_vm.movieInfo[item.id]).toFixed(1) +
                                      "%"
                              )
                            ),
                          ]
                        ),
                      ]),
                    ]
                  }),
                ]
              : [
                  _vm._l(_vm.afterTags, function (item) {
                    return [
                      _c("div", { key: item.id, staticClass: "tag1" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.value) +
                            "\n            "
                        ),
                        _c(
                          "span",
                          {
                            class: [
                              _vm.movieInfo.base < 30 ? "is-warning" : "",
                            ],
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.movieInfo[item.id] === null
                                  ? "-- --"
                                  : Number(_vm.movieInfo[item.id]).toFixed(1) +
                                      "%"
                              )
                            ),
                          ]
                        ),
                      ]),
                    ]
                  }),
                ],
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }